import { useEffect } from "react";
import { useSelector } from "react-redux";

import processHandover from '../../../assets/icons/figma/process-handover.svg'
import ResultPage from "../PageResult";


export default function ProcessHandover() {

  const {
    code,
    componentID,
    referenceID,
    callbackURL,
  } = useSelector(state => ({
    code: state.checkResult.code,
    componentID: state.setApplicationParams.componentID,
    referenceID: state.setApplicationParams.referenceID,
    callbackURL: state.setApplicationParams.callbackURL,
  }));


  const redirectToCaller = () => {
    const eKycProcessStatus = code === '1' ? '400' : '200';
    const paramToCaller = `eKycProcessStatus=${eKycProcessStatus}&transactionID=${componentID}_${referenceID}`
    window.location = `${callbackURL}?${paramToCaller}`
  }

  useEffect(() => {

    const timer = setTimeout(() => {
      redirectToCaller()
    }, 1000)

    return () => clearTimeout(timer);

  }, [])
  
  return (
    <ResultPage
      header={false}
      icon={processHandover}
      titleText={'เรากำลังพาคุณกลับไปยังหน้าหลัก'}
      des={'กรุณารอสักครู่'}
    />
  )
}
